// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const BuiltFlatsPure = createIcon(`
<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="120" height="120"
	 viewBox="0 0 120 120" style="enable-background:new 0 0 120 120;" xml:space="preserve">
<style type="text/css">
	.built-flats0{fill:none;stroke:#0A055F;stroke-width:2.6562;stroke-miterlimit:10;}
	.built-flats1{fill:none;stroke:#FF4114;stroke-width:2.6562;stroke-miterlimit:10;}
</style>
<g>
	<path class="built-flats0" d="M117.5,60c0,31.7-25.8,57.5-57.5,57.5S2.5,91.7,2.5,60S28.3,2.5,60,2.5S117.5,28.3,117.5,60z"/>
	<path class="built-flats1" d="M82.4,40.6c0,3.4-2.8,6.3-6.3,6.3c-3.4,0-6.3-2.8-6.3-6.3c0-3.4,2.8-6.3,6.3-6.3
		C79.6,34.3,82.4,37.1,82.4,40.6z M57.6,30.3c-5.7,5.7-7.5,14-5.1,21.2L23.2,80.7v7.1l2.6,2.6h14.9l2.5-2.5v-8.7h8.7v-8.8h8.7
		l5.2-5.2c7.3,2.4,15.5,0.7,21.3-5.1c8.2-8.2,8.2-21.5,0-29.7C79.1,22.1,65.7,22.1,57.6,30.3z"/>
</g>
</svg>
`);

export const BuiltFlatsIcon: React.SFC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <BuiltFlatsPure className={props.iconClassName} />
);

BuiltFlatsIcon.displayName = 'BuiltFlatsIcon';
